import React from 'react';
import c from 'classnames';
import s from './RootLayout.scss';
const RootLayout = ({ prefix, left, right, className })=>/*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['left-with-prefix']
    }, prefix && /*#__PURE__*/ React.createElement("div", {
        className: s['prefix']
    }, prefix), left && /*#__PURE__*/ React.createElement("div", {
        className: s['left']
    }, left)), right && /*#__PURE__*/ React.createElement("div", {
        className: s['right']
    }, right));
RootLayout.displayName = 'RootLayout';
export default RootLayout;
